import { render } from "./ImpersonationBanner.vue?vue&type=template&id=3828a889&ts=true"
import script from "./ImpersonationBanner.vue?vue&type=script&lang=ts"
export * from "./ImpersonationBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__